import { type FC } from "react";

import LogoIcon from "~/assets/icons/logo.svg?react";
import { useGoToHomePage } from "~/hooks/useGoToHomePage";

import * as Styled from "./AppLogo.styles";

interface IAppLogoProps {
  isSmall?: boolean;
}

export const AppLogo: FC<IAppLogoProps> = ({ isSmall }) => {
  const goToHomePage = useGoToHomePage();

  return (
    <Styled.Root type="button" aria-label="Go to homepage" onClick={goToHomePage}>
      <Styled.SvgIcon component={LogoIcon} $small={isSmall} inheritViewBox />
    </Styled.Root>
  );
};
